import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TransloadOrders_ds_orderline_total_receivedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: {  }): 
  Promise<{ result: { TotalCount?: number, ExpectedCount?: number, OrderId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_orderline_total_received/get`;
    
    const options = {
    }
    
    const body = null;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { TotalCount?: number, ExpectedCount?: number, OrderId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_orderline_total_received/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { $keys: number[] }): 
  Promise<{ result: { TotalCount?: number, ExpectedCount?: number, OrderId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_orderline_total_received/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      }) {
      return false;
    }
}
